<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/O0v5KH/tc-custom/9781439678558.jpg?1704886584345" alt="This image is the cover for the book Cold Case Muncie, True Crime"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cold Case Muncie, True Crime
      </h1>
      <p class="bookDescription body article font2">
        <p><b> The coldest cases from Middletown, USA </b></p> <p>With dozens of unsolved murders spanning decades, Muncie and surrounding Delaware County might have more killings without justice than any American community like it. In 1962, Maggie Mae Fleming was shot to death as she sat in her living room. Paula Garrett was bludgeoned in her home in 1979, and her son, who survived the attack, wants justice. Garth Rector, killed in 2008, could have been murdered by any number of people he knew--or dated.</p> <p>Journalists and award-winning true crime authors Douglas Walker and Keith Roysdon shine a spotlight on the victims, and on their loved ones and the investigators still hoping for resolution to long-cold murders.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Keith Roysdon, Douglas Walker
      </h2>
      
      <p class="authorDescription body article">For most of the past four decades, veteran journalist Douglas Walker has covered the criminal justice system in East Central Indiana for the Star Press and its predecessor, the Muncie Evening Press . He has received dozens of awards for writing, investigative reporting and public service, many the result of collaborations with reporter Keith Roysdon, with whom he also wrote a weekly column on Muncie politics for many years. This marks the duo's fourth book on crime and justice in Muncie and Delaware County. Keith Roysdon is a lifelong Indiana resident who now lives in Tennessee. He has won more than thirty state and national first-place awards for journalism, many for work cowritten by Douglas Walker. Their third book, The Westside Park Murders , was named Best Nonfiction Book of 2021 by the Indiana Society of Professional Journalists. Roysdon's crime novel Seven Angels won the 2021 Hugh Holton Award for Best Unpublished Novel from Mystery Writers of America Midwest.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0bc037c6